/**
 * 样式
 */
import '@resource/css/common.less';
import '@resource/css/public.less';
import '@resource/font/icon/iconfont.less';
